import {SearchEngine} from '../../types/commons';
import {KeyedAction} from '../Store';
import {RootState} from '../State';
import {EngineAction} from '../../model/Search';
import {Injector} from '../../common/Injector';
import {API} from '../../model/API';
import {UserData} from '../../model/api/User';

// Reducer
export type SearchEnginesState = Readonly<{
    engines: SearchEngine[];
}>;

export const SearchEnginesInitialState: SearchEnginesState = {
    engines: []
};

/**
 * Perform a bulk update of the search engines list in the store - for example, after login.
 */
export class GetSearchEngines extends KeyedAction<RootState, 'searchEngines'> {
    public readonly type: string = '@@SEARCH_ENGINES/UPDATE_SEARCH_ENGINES';
    private searchEngines: SearchEngine[] = [];

    constructor() {
        super('searchEngines');
    }

    public async call(store, complete) {
        const api: API = Injector.get('API') as API;
        console.log('Refreshing search engines');
        this.searchEngines = await api.get(UserData.SEARCH_ENGINES);
        await super.call(store, complete);
    }

    public reduce(state: SearchEnginesState): SearchEnginesState {
        return {engines: this.searchEngines};
    }
}

/**
 * Let the controller know that a search engine action is requested.
 */
export class ExecuteEngineAction extends KeyedAction<RootState, 'searchEngines'> {
    public readonly type: string = '@@SEARCH_ENGINES/EXECUTE_ENGINE_ACTION';

    constructor(public readonly action: EngineAction) {
        super('searchEngines');
    }
}

export const getSearchEngines = (state: RootState) => state.searchEngines.engines;
